import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { HelpArticleLink } from '../../components/help-article-link';
import { INSURANCE_HYPERLINK_CLICK } from '../../constants/analytics-events';
import { InsuranceProviders, getInsuranceProviderById } from '../../enums/insurance-providers';
import { ChildrenPropType } from '../../prop-types/children';
import { linkIDs } from '../../services/link-service/links';
import { useTrackInsuranceEvent } from '../hooks/use-track-insurance-event';

// TODO: we may need to generate links (specifically XCover) based on seller locale: https://auctane.atlassian.net/browse/SPD-8964
const termsLinkMap = {
  [InsuranceProviders.Shipsurance.insuranceProviderId]: linkIDs.ShipsuranceTerms,
  [InsuranceProviders.XCover.insuranceProviderId]: linkIDs.XCoverTerms,
  [InsuranceProviders.ParcelGuard.insuranceProviderId]: linkIDs.ParcelGuardTerms,
};

export const InsuranceTermsLink = ({ insuranceProviderId, children, source = '', linkType = 'terms' }) => {
  const trackHyperlinkClick = useTrackInsuranceEvent(INSURANCE_HYPERLINK_CLICK, source);

  const handleClick = useCallback(() => {
    trackHyperlinkClick({ insuranceProvider: getInsuranceProviderById(insuranceProviderId)?.name, linkType });
  }, [insuranceProviderId, linkType, trackHyperlinkClick]);

  return (
    <HelpArticleLink articleId={termsLinkMap[insuranceProviderId]} onClick={handleClick}>
      {children}
    </HelpArticleLink>
  );
};

InsuranceTermsLink.propTypes = {
  insuranceProviderId: PropTypes.string.isRequired,
  children: ChildrenPropType.isRequired,
  source: PropTypes.string,
  linkType: PropTypes.string,
};
